
/**
 * **対象に取られた**（Issue #534）。
 *
 * 開く: `become_target`。**照準の印をオブジェクトレイヤーに置く**ので、
 * **帯が終わっても残る** —— 消すのは `chain_solved` / `chain_end` / `new_turn`（別のファイル）。
 *
 * 帯そのものは「置いた瞬間の光」だけの短いもので、**残るのは印のほう**（設計文書 §4）。
 * 実写でも仮想フィールドでも同じ（旧 `components/fx/effects/target.js` には
 * `inVirtualScene` の分岐と `vfMarker` の 2 経路が要っていた）。
 */
/** 状況ごとのファイル（`../effects/become_target_<variant>_effect.js`）が共有する組み立て（Issue #628。arcade はどの状況も同じ絵） */
export const spec = {
  label: '対象',
  color: '#ff2e3c',

  /**
   * **1 イベントで複数枚が対象になる**（`data.cards`）。`payload.cards` に整えたものが来るので、
   * **場のカードだけ**（墓地・除外・手札を対象に取っても出さない）に絞って渡す。
   */
  opens({ payload }) {
    const cards = (payload?.cards ?? []).filter((c) => c.uid && /^(monster|magic_trap|field):/.test(c.zone ?? ''));
    return cards.length ? { ...payload, cards } : null;
  },

  /** **照準の印を置く**（枚数ぶん。帯が終わっても残る。消すのは別のイベント） */
  places({ payload }) {
    return (payload.cards ?? []).map((c) => ({ mark: 'target', key: c.uid, data: { at: { card: c.uid } } }));
  },

  layers: [
    {
      id: 'lock',
      label: '照準が絞られる光',
      part: 'ring',
      // **枚数ぶん展開する**（`{uid}` はその 1 枚のもの）
      for: 'cards',
      at: { card: '{uid}', else: { zone: '{zone}' } },
      props: { color: '#ff2e3c', ticks: 4 },
      tf: {
        scale: { keys: [{ ms: 0, value: 2.2 }, { ms: 260, value: 1, ease: 'ease_out' }] },
        opacity: { keys: [{ ms: 0, value: 0 }, { ms: 80, value: 1 }, { ms: 420, value: 0 }] },
      },
    },
  ],
};
